import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';
import theme from './theme'; 
import { CartProvider } from './CartProvider';
import CookieConsent from './components/CookieConsent';
import { loadConsent } from './utils/cookieConsent';
import { applyConsentScripts } from './utils/consentScripts';
import RouteTracker from './components/RouteTracker';


export default class App extends Component {
  static displayName = App.name;

  componentDidMount() {
    // On first load, apply scripts based on any previously saved consent
    const consent = loadConsent();
    if (consent) {
      applyConsentScripts(consent);
    }
  }

  handleConsentChanged = (preferences) => {
    applyConsentScripts(preferences);
  };

  render() {
    return (
      <CartProvider>
        <div style={{ backgroundColor: theme.colors.background }}>
          <Layout>
            <RouteTracker />
            <Routes>
              {AppRoutes.map((route, index) => {
                const { element, ...rest } = route;
                return <Route key={index} {...rest} element={element} />;
              })}
            </Routes>
          </Layout>
          <CookieConsent onConsentChanged={this.handleConsentChanged} />
        </div>
      </CartProvider>
    );
  }
}
